const isExternalLink = (url: string) => {
  const uri = new URL(url);
  return !uri.host.includes('coursera.org');
};

export default isExternalLink;
